// GL10 입고작업조회 2.0 — moms-be 호출부. 1.0 공통 그리드(/api/common/gridsub · /api/grid/search · /api/common/file)와
// /api/internal/data/send · /api/internal/data/create 는 쓰지 않는다 (LOGISPRD-16038).
import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import { INBOUND_WORK_SEARCH_MENU_CODE } from './consts'
import type { InboundWorkRowDto, InboundWorkSearchReq } from './types'

export const INBOUND_WORK_SEARCH_URL = '/api/v1/global/inbound-works/search'

/**
 * 조회 — UI_GLOBAL_INVOICE_HIS. 1.0 처럼 페이징 없이 전체를 받는다(기간 필수, 최대 31일).
 * 입고송장번호를 수백 건 넣는 쓰임이 있어 GET 쿼리 대신 POST 본문으로 보낸다(URL 한도). 1.0 조회도 POST 였다.
 */
export const searchInboundWorks = (body: InboundWorkSearchReq) =>
  request.post<ApiResponseV2<InboundWorkRowDto[]>, InboundWorkSearchReq>(
    INBOUND_WORK_SEARCH_URL,
    body,
    menuCodeHeaders(INBOUND_WORK_SEARCH_MENU_CODE),
  )
